
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControlDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { StaticDictionaryService } from 'src/app/shared/services/static-dictionary.service';
import { ControlSettings } from '../../ControlSettings';


@Component({
  selector: 'list-select-ctrl',
  templateUrl: './list-select.component.html',
  styleUrls: ['./list-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: ListSelectComponent,
    multi: true
  }]
})
export class ListSelectComponent implements ControlValueAccessor,OnInit  {

  constructor(protected controlContainer: ControlContainer, private staticDictionary: StaticDictionaryService) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  

  @Input() public formControlName: string;
  @Input() caption: string;
 
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {fxFill:false};

  @Input() valuesList$: Observable<any[]>;
  @Input() textField :string;
  @Input() valueField : string;

  @Input() primitiveValue  = true;
 
  @Output() valueChangeEvent = new EventEmitter<any>();

  ngOnInit(): void {
     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;
  }

  onChange(value: any) {
    this.valueChangeEvent.emit(value);
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }


}
